import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import { LobbyBannerProvider } from 'commons-ui';
import CloneBanner from './submodules/clone';
import CreateBanner from './submodules/create';
import ListBanner from './submodules/list';
import EditBanner from './submodules/edit';

const LobbyBannerDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<LobbyBannerProvider>
				<AuthorizedRoute
					entity={DASHBOARD_RESOURCES.lobbyBanner}
					actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.lobbyBanner].getAllBanners]}
					configPageName={PAGE_NAMES.dashboard}
					path={`${path}/list`}
					component={ListBanner}
					exact
				/>
				<AuthorizedRoute
					entity={DASHBOARD_RESOURCES.lobbyBanner}
					actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.lobbyBanner].addBanners]}
					configPageName={PAGE_NAMES.dashboard}
					path={`${path}/clone`}
					component={CloneBanner}
					exact
				/>
				<AuthorizedRoute
					entity={DASHBOARD_RESOURCES.lobbyBanner}
					actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.lobbyBanner].addBanners]}
					configPageName={PAGE_NAMES.dashboard}
					path={`${path}/create`}
					component={CreateBanner}
					exact
				/>
				<AuthorizedRoute
					entity={DASHBOARD_RESOURCES.lobbyBanner}
					actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.lobbyBanner].updateBannerStatus]}
					configPageName={PAGE_NAMES.dashboard}
					path={`${path}/edit`}
					component={EditBanner}
					exact
				/>
				<Redirect to={`${path}/list`} />
			</LobbyBannerProvider>
		</Switch>
	);
};

export default LobbyBannerDashboard;
